import { CloseCircleFilled, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { useMessage } from 'components/ui';

const StyledMessageDiv = styled.div`
  display: flex;
`;

const StyledCloseCircleFilled = styled(CloseCircleFilled)`
  top: 3px;
`;

const StyledCloseOutlined = styled(CloseOutlined)`
  top: 3px;
  margin-left: 8px;
  color: ${({ theme }) => theme.overlay};
`;

const StyledMessageContent = styled.span`
  text-align: left;
`;

interface IMultiLineErrorMessage {
  messageContent: string;
}

// Styles an error message for use with AntD's error messages
export const MultiLineErrorMessage = ({ messageContent = '' }: IMultiLineErrorMessage) => {
  const message = useMessage();
  return (
    <StyledMessageDiv>
      <StyledCloseCircleFilled />
      <StyledMessageContent>{messageContent}</StyledMessageContent>

      <StyledCloseOutlined
        onClick={() => {
          message.destroy();
        }}
      />
    </StyledMessageDiv>
  );
};
